/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
if (window.matchMedia("(max-width: 768px)").matches) {
  	window.onscroll = function() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
	}
} 

function parcelamento() {
  var preco = $('.product-form__info-item .price--highlight').text().split('                  ')[0].replace('R$ ','').replace(',', '.').trim()
  var compare = $('.product-form__info-item .price--compare').text().replace('ars ', '').replace(',','.')
  var compare = parseFloat(compare)
  var precompare = (compare - preco).toFixed(2).replace('.', ',')
  $('.product-label.product-label--on-sale span').text('R$ '+ precompare)
  var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0]
  $('.price--highlight .product-label.product-label--on-sale').append('-' + porcent + '%')    
  var preco = parseFloat(preco);
  var calculo = ((preco + 0) * 1.1979) / 12;
  var calculo = calculo.toFixed(2).replace('.', ',');
  var calculo = ('R$ ' + calculo);
  $('.cuotas sin interés ').html('<span>de 12x de <b>' + calculo + '</b></span>');
}
$(".block-swatch__radio").change(function () {
  setTimeout(function () { parcelamento(); }, 150);
});
// ===== MINI-CART DRAWER LATERAL =====
document.addEventListener('DOMContentLoaded', function() {
  var miniCart = document.querySelector('.mini-cart');
  if (!miniCart) return;

  // Mover al body para sacarlo del header
  document.body.appendChild(miniCart);

  // Forzar estilos inline (gana sobre cualquier CSS del tema)
  function applyDrawerStyles() {
    miniCart.style.setProperty('position', 'fixed', 'important');
    miniCart.style.setProperty('top', '0', 'important');
    miniCart.style.setProperty('right', '0', 'important');
    miniCart.style.setProperty('left', 'auto', 'important');
    miniCart.style.setProperty('bottom', '0', 'important');
    miniCart.style.setProperty('width', '500px', 'important');
    miniCart.style.setProperty('max-width', '100vw', 'important');
    miniCart.style.setProperty('height', '100vh', 'important');
    miniCart.style.setProperty('max-height', '100vh', 'important');
    miniCart.style.setProperty('overflow-y', 'auto', 'important');
    miniCart.style.setProperty('z-index', '99999', 'important');
    miniCart.style.setProperty('background', '#ffffec', 'important');
    miniCart.style.setProperty('box-shadow', '-4px 0 24px rgba(0,0,0,0.18)', 'important');
    miniCart.style.setProperty('border-left', '3px solid #ccc8aa', 'important');
    miniCart.style.setProperty('border-radius', '0', 'important');
    miniCart.style.setProperty('padding', '0', 'important');
    miniCart.style.setProperty('margin', '0', 'important');
    miniCart.style.setProperty('visibility', 'visible', 'important');
    miniCart.style.setProperty('opacity', '1', 'important');
    miniCart.style.setProperty('will-change', 'transform', 'important');
    miniCart.style.setProperty('transition', 'transform 0.35s cubic-bezier(0.4,0,0.2,1)', 'important');
    miniCart.style.setProperty('transform', 'translateX(100%)', 'important');
  }

  applyDrawerStyles();

  // Crear overlay
  var overlay = document.createElement('div');
  overlay.style.cssText = 'display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:99998;';
  document.body.appendChild(overlay);

  function openDrawer() {
    applyDrawerStyles();
    miniCart.style.transform = 'translateX(0) !important';
    miniCart.style.setProperty('transform', 'translateX(0)', 'important');
    miniCart.setAttribute('aria-hidden', 'false');
    overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
    miniCart.scrollTop = 0;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function closeDrawer() {
    miniCart.style.setProperty('transform', 'translateX(100%)', 'important');
    miniCart.setAttribute('aria-hidden', 'true');
    overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  // Cerrar al hacer clic en el overlay
  overlay.addEventListener('click', closeDrawer);

  // Abrir al agregar producto al carrito
  document.addEventListener('product:added', openDrawer);

  // Interceptar clic en el ícono del carrito
  document.addEventListener('click', function(e) {
    var cartToggle = e.target.closest('[href*="/cart"], [data-action="open-cart"], .header__icon--cart, [aria-controls="mini-cart"]');
    if (cartToggle) {
      e.preventDefault();
      e.stopPropagation();
      if (miniCart.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      } else {
        openDrawer();
      }
    }
  }, true);

  // Observar si el tema intenta cambiar aria-hidden
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.attributeName === 'aria-hidden') {
        if (miniCart.getAttribute('aria-hidden') === 'false') {
          applyDrawerStyles();
          miniCart.style.setProperty('transform', 'translateX(0)', 'important');
          overlay.style.display = 'block';
          document.body.style.overflow = 'hidden';
          miniCart.scrollTop = 0;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          miniCart.style.setProperty('transform', 'translateX(100%)', 'important');
          overlay.style.display = 'none';
          document.body.style.overflow = '';
        }
      }
    });
  });
  observer.observe(miniCart, { attributes: true });

  // Re-aplicar estilos si el tema los resetea
  new MutationObserver(function() {
    if (miniCart.getAttribute('aria-hidden') !== 'false') {
      miniCart.style.setProperty('transform', 'translateX(100%)', 'important');
    }
    miniCart.style.setProperty('position', 'fixed', 'important');
    miniCart.style.setProperty('top', '0', 'important');
    miniCart.style.setProperty('right', '0', 'important');
    miniCart.style.setProperty('height', '100vh', 'important');
    miniCart.style.setProperty('z-index', '99999', 'important');
  }).observe(miniCart, { attributes: true, attributeFilter: ['style'] });
});
// ===== FIX BOTÓN QUITAR EN DRAWER =====
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.mini-cart__quantity-remove');
  if (!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  var key = btn.getAttribute('data-line-id');
  if (!key) return;

  btn.style.opacity = '0.4';
  btn.style.pointerEvents = 'none';

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  })
  .catch(function() {
    btn.style.opacity = '1';
    btn.style.pointerEvents = 'auto';
  });
}, true); // <-- true = capture phase, se ejecuta ANTES que el listener del tema

